import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { ContainerPanel } from "@src/components/organisms/container-panel/container-panel";
import { MainContainer } from "@src/components/templates/layouts/main-container/main-container";
import { RoundBorderComponentContainer } from "@src/components/templates/layouts/round-border-component-container/round-border-component-container";
import React from "react";
import { MachineOverviewContainer } from "../../organisms/machine-overview-container/machine-overview-container";
import { MachineOverviewContainerDrBoy } from "../../organisms/machine-overview-container-dr-boy/machine-overview-container-dr-boy";
import { MachineOverviewContainerChenHsong } from "../../organisms/machine-overview-container-chen-hsong/machine-overview-container-chen-hsong";
import { StaticMachineOverviewContainerForTt } from "@src/components/organisms/static-machine-overview-container-for-tt/static-machine-overview-container-for-tt";
import { staticTTMachinesData } from "@src/components/pages/factory-dashboard/static-tt-data";
import styles from "./factory-dashboard-page.module.scss";
import { ContainerPane } from "@src/components/organisms/container-pane/container-pane";
import { useI18N } from "@src/language/language-context";
import { useFactoryDashboard } from "./use-factory-dashboard";
import { useIsDrBoyNamespace } from "@src/hooks/use-is-dr-boy-namespace";
import { useIsTTNamespace } from "@src/hooks/use-is-tt-namespace";
import { staticIMMACMachinesData } from "./static-immac-data";
import { useIsImmacNamespace } from "@src/hooks/use-is-immac-namespace";
import { useIsChenHsongSouthAmericaNamespace } from "@src/hooks/use-is-chen-hsong-south-america-namespace";
import { useFeatureFlag } from "@src/hooks/use-feature-flag";

const cssClassName = "factory-dashboard-page";

export const FactoryDashboardPage = () => {
  const i18n = useI18N();
  const machines = useFactoryDashboard();
  const isDrBoyNamespace = useIsDrBoyNamespace();
  const isTTNamespace = useIsTTNamespace();
  const isIMMACNamespace = useIsImmacNamespace();
  const isChenHsongSouthAmericaNamespace =
    useIsChenHsongSouthAmericaNamespace();
  const isChenHsongUser = useFeatureFlag("isChen-hsong-user", false);
  const machineOverviewCards = (() => {
    if (isTTNamespace) {
      return staticTTMachinesData.map((machine) => (
        <StaticMachineOverviewContainerForTt
          key={machine.machineName}
          machine={machine}
          gridArea="quarter"
        />
      ));
    }

    if (isDrBoyNamespace) {
      return machines.map((machine) => (
        <MachineOverviewContainerDrBoy
          key={machine.sourceId}
          machine={machine}
          gridArea="quarter"
        />
      ));
    }

    if (isChenHsongSouthAmericaNamespace && isChenHsongUser === true) {
      return machines.map((machine) => (
        <MachineOverviewContainerChenHsong
          key={machine.sourceId}
          machine={machine}
          gridArea="quarter"
        />
      ));
    }

    if (isIMMACNamespace) {
      return staticIMMACMachinesData.map((machine) => (
        <StaticMachineOverviewContainerForTt
          key={machine.machineName}
          machine={machine}
          gridArea="quarter"
        />
      ));
    }

    return machines.map((machine) => (
      <MachineOverviewContainer
        key={machine.sourceId}
        machine={machine}
        gridArea="quarter"
      />
    ));
  })();

  return (
    <MainContainer>
      <RoundBorderComponentContainer>
        <ContainerPanel>
          <SubHeader>
            <SubTitle text={i18n("modules.factoryDashboardPage.title")} />
          </SubHeader>
          <ContainerPane>
            <div className={styles[cssClassName]}>{machineOverviewCards}</div>
          </ContainerPane>
        </ContainerPanel>
      </RoundBorderComponentContainer>
    </MainContainer>
  );
};
